// Club pack password functionality
function initClubPackPassword(config) {
  const { salt, expectedHash, storageKey } = config;
  const modal = document.querySelector('[data-club-pack-modal]');
  const form = modal ? modal.querySelector('[data-club-pack-form]') : null;
  const input = form ? form.querySelector('input[name="club_pack_password"]') : null;
  const errorEl = modal ? modal.querySelector('[data-club-pack-error]') : null;
  
  if (!form || !input) return;
  
  // Check if already unlocked for this specific club/collection
  try {
    if (localStorage.getItem(storageKey) === '1') {
      document.documentElement.classList.add('club-pack-unlocked');
      if (modal && modal.parentNode) {
        modal.parentNode.removeChild(modal);
      }
      return;
    }
  } catch(e) {}
  
  const unlock = () => {
    try {
      // Set only the specific key for this club/collection
      localStorage.setItem(storageKey, '1');
    } catch(e) {}
    document.documentElement.classList.add('club-pack-unlocked');
    if (modal && modal.parentNode) {
      modal.parentNode.removeChild(modal);
    }
  };
  
  // Focus input after a moment
  setTimeout(() => input.focus(), 100);
  
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const password = (input.value || '').trim();
    
    try {
      if (!window.crypto || !window.crypto.subtle) {
        throw new Error('WebCrypto unavailable');
      }
      
      const saltedInput = salt + password;
      const encoder = new TextEncoder();
      const data = encoder.encode(saltedInput);
      const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
      
      if (hashHex === expectedHash) {
        unlock();
        return;
      }
    } catch(e) {
      console.error('Password validation error:', e);
    }
    
    if (errorEl) {
      errorEl.textContent = 'Incorrect password. Try again.';
    }
    input.value = '';
    input.focus();
  });
}

// Auto-init if window.clubPackPasswordConfig is set
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    if (window.clubPackPasswordConfig) {
      initClubPackPassword(window.clubPackPasswordConfig);
    }
  });
} else {
  if (window.clubPackPasswordConfig) {
    initClubPackPassword(window.clubPackPasswordConfig);
  }
}
